
// New component for dynamic event access error
const DynamicEventAccessError = () => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
    <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-lg text-center">
      <div className="bg-red-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
        <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
        </svg>
      </div>
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Event Access Restricted</h2>
      <p className="text-gray-600 mb-6">
        This event uses dynamic QR codes and requires an invitee-specific link. 
        Please use the specific link provided to you by the event organizer.
      </p>
      <button 
        onClick={() => window.location.href = '/'}
        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition duration-200"
      >
        Return to Home
      </button>
    </div>
  </div>
);
export default DynamicEventAccessError